import { Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { EmpresaUsuario } from '../../../main/objetos/empresa';
import { Usuario } from '../../../main/objetos/usuario';
import { Cajero } from '../../../main/objetos/cajero';
import { SimpleResponse } from '../../../main/objetos/simple-response';
import { DocumentosService } from '../documentos.service';
@Injectable({
  providedIn: 'root',
})
export class UsuarioUtilsService {
  usuario: Usuario = {} as Usuario;
  cajeros: Cajero[] = [];

  private impresoraSignal: WritableSignal<string> = signal('');

  private esUsuarioTablet: boolean = false;

  constructor(private documentosService: DocumentosService) {}

  inicializarUsuario() {
    this.usuario = JSON.parse(localStorage.getItem('user') || '{}');
    this.esUsuarioTablet =
      this.usuario.correo?.toLowerCase().startsWith('tt') || false;
  }

  obtenerEmpresaUsuario(): EmpresaUsuario {
    this.inicializarUsuario();
    const usuarioActual: Usuario = JSON.parse(
      localStorage.getItem('user') || 'null'
    );

    if (!usuarioActual) {
      return {
        empresaId: 0,
        limiteFondoCaja: 0,
        nombreComercial: '',
        promocionesId: 0,
        sucursalIdMicrosip: 0,
        dns: '',
        ticketDigital: false,
        qr_satisfaccion: '',
        qr_facturacion: '',
        onix: false,
      };
    }

    const empresa = usuarioActual.empresasUsuario?.[0];

    return {
      empresaId: empresa?.empresaId || 0,
      limiteFondoCaja: empresa?.limiteFondoCaja || 0,
      nombreComercial: empresa?.nombreComercial || '',
      promocionesId: empresa?.promocionesId || 0,
      sucursalIdMicrosip: empresa?.sucursalIdMicrosip || 0,
      dns: empresa?.dns || '',
      ticketDigital: empresa?.ticketDigital || false,
      qr_satisfaccion: empresa?.encuestaQR || '',
      qr_facturacion: empresa?.urlFacturas || '',
      onix: empresa?.onix || false,
      esAeropuerto: empresa?.esAeropuerto || false,
      esCruzRoja: empresa?.esCruzRoja || false,
    };
  }

  obtenerCajasPorUsuario = (): {
    cajaId: string;
    impresora?: string;
  }[] => {
    if (this.usuario.cajerosUsuario?.length === 0) {
      return [];
    }
    const cajas = (this.usuario.cajerosUsuario ?? [])
      .filter((caja: any) => caja.cajaIdMicrosip !== undefined)
      .map((caja: any) => ({
        cajaId: caja.cajaIdMicrosip!.toString(),
        impresora: caja.cajas[0]?.impresora,
        empresaId: caja.empresaId,
      }));
    const cajaEmpresa = cajas.find(
      (caja) => caja.empresaId === this.usuario.empresasUsuario?.[0]?.empresaId
    );
    this.impresoraSignal.set(cajaEmpresa?.impresora || '');
    return cajas;
  };

  obtenerCajerosPorUsuarioEmpresa = () => {
    this.documentosService
      .obtenerCajerosPorUsuarioEmpresa(
        Number(this.usuario.id),
        Number(this.obtenerEmpresaUsuario().empresaId)
      )
      .subscribe((response: SimpleResponse) => {
        this.cajeros = response.payload.map((cajero: any) => ({
          nombre: cajero.nombreCajero,
          id: cajero.cajeroIdMicrosip,
          cajaIdMicrosip: cajero.cajaIdMicrosip,
        }));
        return this.cajeros;
      });
  };

  obtenerEsUsuarioTablet(): boolean {
    return this.esUsuarioTablet;
  }

  get obtenerImpresora(): Signal<string> {
    return this.impresoraSignal;
  }
}
